import dayjs from 'dayjs';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import {
    rgbaToHex
} from '../utils';

const MIN_ZOOM = 0;
const MAX_ZOOM = 19;
const WEATHER_OPACITY = 0.4;
const DEBOUNCE_TIME_MS = 300;

export const generateRainViewerTileLayers = async (zIndex) => {
    const size = 256;
    const color = 1;
    const options = '1_0';

    return fetch("https://api.rainviewer.com/private/a9efc817-9f13-419a-ab13-577496e8e311/weather-maps.json")
        .then(res => res.json())
        .then(apiData => {
            const {
                host: baseUrl,
                radar: { nowcast, past }, // nowcast: 30min forecast, past: previous 2h 
            } = apiData;

            const createTileLayers = model => model.map(({ path, time }) => {
                const layer = new TileLayer({
                    id: `TileLayer_${time}`,
                    data: `${baseUrl}${path}/${size}/{z}/{x}/{y}/${color}/${options}.png`,
                    maxZoom: 19,
                    minZoom: 0,
                    opacity: WEATHER_OPACITY,
                    zIndex,
                    time,

                    renderSubLayers: props => {
                        const { bbox: { north, east, south, west } } = props.tile;
                        const bounds = [west, south, east, north];

                        return new BitmapLayer(props, {
                            data: null,
                            image: props.data,
                            bounds,
                        });
                    },
                });
                return layer;
            });

            const layers = [...createTileLayers(past), ...createTileLayers(nowcast)];
            return layers;
        });
};

const overlayKeyToGradientStr = key => key.toReversed().map(({ rgba }, i) => `${i}:${rgbaToHex(rgba)}`).join();
const createQueryParams = paramsObj => Object.keys(paramsObj).map(key => `${key}=${paramsObj[key]}`).join('&');

export const generateTomorrowIoTileLayers = async (zIndex, time, weatherOverlayKey = []) => { // time is unix time
    const baseUrl = 'https://api.tomorrow.io/v4';
    const path = 'map/tile';
    const field = 'precipitationIntensity';
    const format = 'png';
    const accessToken = process.env.VITE_APP_TOMORROW_IO_API_KEY;
    const timeISOString = dayjs.unix(time).toISOString();
    const queryParams = {
        apikey: accessToken,
        gradient: overlayKeyToGradientStr(weatherOverlayKey),
    };

    const layer = new TileLayer({
        id: `TileLayer_${time}`,
        data: `${baseUrl}/${path}/{z}/{x}/{y}/${field}/${timeISOString}.${format}?${createQueryParams(queryParams)}`,
        maxZoom: MAX_ZOOM,
        minZoom: MIN_ZOOM,
        opacity: WEATHER_OPACITY,
        zIndex,
        time,
        debounceTime: DEBOUNCE_TIME_MS,

        renderSubLayers: props => {
            const { bbox: { north, east, south, west } } = props.tile;
            const bounds = [west, south, east, north];

            return new BitmapLayer(props, {
                data: null,
                image: props.data,
                bounds,
            });
        },
    });
    return layer;
};

const generateTileLayers = {
    rainViewer: zIndex => generateRainViewerTileLayers(zIndex),
    tomorrowIo: (zIndex, times, weatherOverlayKey) => generateTomorrowIoTileLayers(zIndex, times, weatherOverlayKey),
};

export default generateTileLayers;